/** User-facing product brand (keep DB/path names as class_points). */
export const BRAND_NAME = "班级积分管理系统";
export const BRAND_TAGLINE = "班级积分系统";
